import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getPublicToken } from "../../shared/api/token";
import { SimpleResult } from "../../shared/interfaces/api";
import {
    GetPopulateLeadArgs,
    LeadRequest,
    PopulateLeadResponse,
} from "../interfaces/facilityapi";

export const facilityApi = createApi({
    reducerPath: "facilityApi",
    baseQuery: fetchBaseQuery({
        baseUrl: "/api/",
        prepareHeaders: (headers) => {
            const token = getPublicToken();
            headers.set("Authorization", `Bearer ${token}`);
            return headers;
        },
    }),
    endpoints: (builder) => ({
        getPopulateLead: builder.query<
            PopulateLeadResponse,
            GetPopulateLeadArgs
        >({
            query: ({ facilityId }) =>
                `facility/PopulateLeadForm/${facilityId}`,
        }),
        sendLead: builder.mutation<SimpleResult, LeadRequest>({
            query: (postdata) => ({
                url: "facility/SendLead",
                method: "POST",
                body: JSON.stringify(postdata),
                headers: {
                    "Content-Type": "application/json",
                },
            }),
        }),
    }),
});

// export hooks
export const {
    useGetPopulateLeadQuery,
    useSendLeadMutation,
    //usePostMeetingCreateMutation
} = facilityApi;
